import { useQuery } from '@tanstack/react-query';
import api from 'src/api';
import d from 'dayjs';

export function useCalendarEntries({
  from,
  to,
  propertyId,
  onSuccess,
  enabled = true,
  
  roomId
}) {
  const { data: calendarEntries = [], ...rest } = useQuery({
    queryKey: [
      'calendar-entries',
      propertyId,
      from?.format?.('YYYY-MM-DD'),
      to?.format?.('YYYY-MM-DD'),
      roomId
    ],
    enabled: !!propertyId && d(from).isValid() && enabled,
    queryFn: async () => {
      if (!d(from).isValid()) return;
      if (!to) to = from.add(1, 'd');

      const { data } = await api.get('/calendar', {
        params: {
          propertyId,
          from: from.format('YYYY-MM-DD'),
          to: to.format('YYYY-MM-DD'),
          roomTypeId: roomId
        }
      });
      // console.log({data, from,})
      const entries = data?.calendarEntries || [];
      onSuccess?.(entries);
      return entries;
    }
  });

  return { calendarEntries, ...rest };
}